import gql from 'graphql-tag';
import { reportGQLFields } from './report.fields.js';
export function getReportGQLQuery(fields) {
    return gql `
    query getReport(
      $input: ReportInput!
      $spaceId: String
    ){
      report(input: $input, spaceId: $spaceId) {
        ${reportGQLFields(fields)}
      }
    }
  `;
}
//# sourceMappingURL=report.gql.js.map